module.exports = __webpack_public_path__ + "assets/img/img197.f1a932d6.png";